export const de = {
    text: {
        continue: 'Weiter',
        yes: 'Ja',
        no: 'Nein',
        back: 'Zurück',
        backToHomepage: 'Zurück zur Startseite',
    },
    nonGermanSpeaking: {
        title: 'Unsere {destination} Experten sprechen leider nur Englisch. Möchtest du trotzdem fortfahren?',
        tip: 'Unsere Experten in {destination} sprechen zwar nicht Deutsch, kennen ihr Land aber um so besser.',
        footer: 'Um fortzufahren wähle aus ob du auch auf Englisch planen möchtest.',
        planEnglish: 'Ja, ich möchte weiterhin mit Experten planen',
        planGerman: 'Nein, das kommt für mich nicht in Frage',
        declined: 'Leider können unsere Experten dir zur Zeit nicht weiterhelfen.',
        disclaimer: 'Lokale Experten in {destination} zu finden, die sowohl unsere Qualitätsstandards erfüllen als auch Deutsch sprechen, war uns bisher nicht möglich.<br>' +
            'Wir lieben es uns zu verbessern und werden daher versuchen bald eine {destination} Reiseplanung mit lokalen, deutschsprachigen Experten zu ermöglichen.<br>' +
            'Zur Zeit bieten wir jedoch {countGermanSpeaking} andere Destinationen mit deutschsprachigen Experten vor Ort an.',
    },
    introductionText: 'In den nächsten 2 Minuten geht es um deine ersten Wünsche für {destination}. Per Email erhältst du dann in spätestens 48 Stunden deinen ersten Reisevorschlag!',
    groupForm: {
        title: 'Lass uns deine Reiseplanung starten.\n Mit wem möchtest du {destination} erleben?',
        single: 'Allein',
        pair: 'Zu Zweit',
        group: 'Als Gruppe',
        family: 'Als Familie',
        footer: 'Um fortzufahren wähle aus mit wem Du {destination} erleben möchtest.',
    },
    groupSize: {
        title: 'Ihr seid also als {groupForm} unterwegs.<br> Wie sieht diese aus?',
        infoFamily: 'Unsere Experten beraten dich gerne wie deine {destination} Reise für deine Familie familiengerecht geplant werden kann.',
        infoGroup: 'Solltest du dich einer Reisegruppe anschließen wollen, kannst du das auch später noch deinem Experten mitteilen.',
        grownups: 'Erwachsene<br>(ab 13 Jahren)',
        children: 'Kinder<br>(2-12 Jahre)',
        babies: 'Kleinkinder<br>(Unter 2 Jahren)',
        group: 'Gruppe',
        family: 'Familie',
    },
    timeframe: {
        titleTimeframeRequest: 'Wir planen also für {groupSize}.<br>Wann möchtest du {destination} erleben?',
        titleDateKnown: 'Super! Wann ist deine geplante An- & Abreise?',
        titleDateUnknown: 'Kein Problem.<br> Für wann planst du deine {destination} Reise?',
        titleMonthUnknown: '{year} klingt gut.<br> Welcher Monat passt dir am besten?',
        titleDurationUnknown: 'Soweit so gut. {year} im {month}. <br> Wie lange möchtest du unterwegs sein?',
        dateKnown: "Ich kenne An- & Abreisedatum",
        knownTip: "Nicht ganz sicher? Die Reisedauer kannst du zu einem späteren Zeitpunkt noch problemlos ändern.",
        knownRecommendedDurationTip: 'Für diese Route empfehlen unsere Experten {recommendedDuration} Tage. Gerne passt dein Experte die Dauer an deine Wünsche an.',
        dateUnknown: "Ich habe einen ungefähren Reisezeitraum",
        unknownYear: "Ich plane für {year}",
        unknownTip: "Die beste Reisezeit für {destination} haben wir mit einem Stern markiert.",
        minDurationTip: "75% der Reisenden, die {destination} zum ersten Mal besuchen, reisen für mehr als {minDuration} Tage. Deine Reisedauer kannst du auch später noch problemlos anpassen.",
        minDurationRouteTip: "Unsere Experten empfehlen für diese Route eine Reisedauer von {minDuration} Tagen. Gerne kürzen bzw. verlängern wir diese Route um deinen Wünschen gerecht zu werden.",
        departure: 'Abreise',
        arrival: 'Ankunft',
        months: {
            january: "Januar",
            february: "Februar",
            march: "März",
            april: "April",
            may: "Mai",
            june: "Juni",
            july: "Juli",
            august: "August",
            september: "September",
            october: "Oktober",
            november: "November",
            december: "Dezember",
        },
        duration: {
            specific: '{duration} Tage',
            oneWeek: '1 Woche',
            twoWeeks: '2 Wochen',
            threeWeeks: '3 Wochen',
            fourWeeks: '4 Wochen',
            fiveToEight: '5 - 8 Tage',
            nineToTwelve: '9 - 12 Tage',
            fourteenToSeventeen: '14 - 17 Tage',
            nineteenToTwentytwo: '19 - 22 Tage',
            twentyfiveToTwentyeight: '25 - 28 Tage',
        },
        footer: 'Um fortzufahren wähle eine Option zum Reisezeitraum aus.',
    },
    dateUnknown: {
        titleDateUnknown: 'Wir planen also für {groupForm}. Wann möchtest du {destination} erleben?',
    },
    flightBooked: {
        title: 'Hast du schon einen Flug für deine {destination} Reise gebucht?',
        yes: "Ja, Flug wurde bereits gebucht",
        no: "Nein, noch nicht",
        footer: "Um fortzufahren gib an, ob du schon einen Flug gebucht hast.",
    },
    flightDetails: {
        title: 'Verrate uns bitte, wo du in {destination} landen wirst und von wo du Deine Heimreise antreten wirst? ',
        info: ' Wenn du den Namen der Flughäfen gerade nicht weißt, kannst du das auch noch später angeben. ',
        arrivalAirport: 'Ankunftsflughafen',
        departureAirport: 'Rückflughafen',
    },
    messageBox: {
        title: 'Erzähle deinem Reiseexperten von deinen Vorstellungen & deinen Wünschen',
        info: ' <b>Was uns besonders interessiert:</b><br>' +
            '<ul class="dashed"><li>Was möchtest Du in {destination} erleben?</li>' +
            '<li>Wie möchtest Du unterwegs sein?</li>' +
            '<li>Was ist Dir auf Deiner Reise besonders wichtig?</li></ul>',
        infoEnglish: '<b>Unsere Experten in {destination} sprechen zwar kein Deutsch - sie kennen ihr Land aber umso besser. Was uns besonders interessiert:</b><br>' +
            '<ul class="dashed"><li>Was möchtest Du in {destination} erleben?</li>' +
            '<li>Wie möchtest Du unterwegs sein?</li>' +
            '<li>Was ist Dir auf Deiner Reise besonders wichtig?</li></ul>',
        placeholder: '- Was möchtest Du in {country} erleben?\n  (z.B. Natur, Kultur etc.) \n- Wie möchtest Du unterwegs sein?\n  (z.B. Mietwagen, Guide etc.) \n- Was ist Dir auf Deiner Reise besonders wichtig?\n  (z.B. Reiseziele, Komfortlevel etc.)',
        footer: 'Erzähle von Deinen Wünschen und klicke dann auf den Weiter Button.',
    },
    budget: {
        budgetTip: '80% unserer Reisenden wählen für eine {duration}-Tägige {destination} Reise ein Budget von mehr als {recommendedPrice}€ pro Person',
        title: 'Mit welchem Budget dürfen wir deine Reiseplanung starten?',
        placeholder: 'Budget hier eintragen',
        inputInfo: '€ pro Person ohne Flug',
        budgetTooLowInfo: '<b>Dein Vertrauen ist uns wichtig:</b> Unsere Experten verwirklichen deine Wünsche mit einem realistischen Budget ohne es unnötig zu strapazieren.',
        budgetTooLow: 'Ein Budget von {budget}€ pro Person für {duration} Tage {destination} ist äußerst niedrig (ca. {difference}% unter dem Durchschnitt).',
        budgetTooLowText: 'Erfahrungsgemäß ist mindestens ein Budget von {recommendedPrice}€ pro Person nötig, um einen unverbindlichen Vorschlag ausarbeiten zu können. <br>' +
            'Bitte überdenke nochmals deine Budgetangaben.',
        budgetIncorrect: 'Bitte gib dein Budget nur in Zahlen an.',
        footer: 'Deine Budgetangabe hilft unseren Experten die Machbarkeit deiner Wünsche einzuschätzen.'
    },
    personalInformation: {
        informationTip: 'Per Email & unverbindlich kontaktiert dich in den nächsten 48 Stunden dein persönlicher Reiseexperte. <br><b><a target="_blank" href="/de/service/datenschutz">Zu unserer Datenschutzerklärung &rarr;' + '</a></b>',
        title: 'Für wen dürfen wir unverbindlich planen?',
        firstName: 'Vorname',
        lastName: 'Nachname',
        email: 'E-Mail Adresse',
        birthDate: 'Geburtsdatum',
        day: 'TT',
        month: 'MM',
        year: 'JJJJ',
        agbConfirmation: 'Ich bestätige die <a class="tw-underline hover:tw-text-brand" target="_blank" href="/allgemeine-geschaeftsbedingungen">AGB</a> von WeDesignTrips',
        mailchimpSignup: 'Ich möchte den Newsletter mit spannenden Reiseerlebnissen & Insidertipps erhalten (Du kannst Dich jederzeit abmelden). <a class="tw-underline hover:tw-text-brand" target="_blank" href="/de/service/datenschutz">Datenschutzerklärung</a>',
        submit: 'Jetzt unverbindliches Reiseangebot anfragen',
    },
    successfulSubmission: {
        title: "Danke {name} für dein Vertrauen! <br>Deine Anfrage ist nun in Bearbeitung!",
        info: "Dein Reiseexperte ruft dich gerne zu einem vereinbarten Termin per Telefon an. So kannst du noch einfacher deine Reise planen & dem Experten mehr über deine Wünsche erzählen.",
        phoneRequest: "Möchtest du noch schneller & direkter deine {destination} Reise planen?",
        label: "Nichts ist persönlicher als ein Gespräch:",
        placeholder: "Deine Telefonnummer",
        button: "Reiseplanung vereinfachen",
        noPhoneNumber: "Nein, danke. Ich möchte lieber per Email kontaktiert werden.",
        spamLabel: "Achtung: solltest du innerhalb von 48 Stunden keine Mail von uns erhalten haben, checke bitte deinen Spam Ordner.",
    },
    rating: {
        title: "Danke {name} für dein Vertrauen! <br> Dein Reiseexperte wird sich in den nächsten 48 Stunden bei dir per Mail melden.",
        message: "<b>Wir lieben es uns zu verbessern.</b><br>Wie zufrieden bist du mit unserem Online-Formular zu deinen Reisewünschen?",
        highRating: "Nicht zufrieden",
        lowRating: "Sehr zufrieden",
    },
    errorMessages: {
        missingFirstName: 'Bitte Vornamen eingeben',
        missingLastName: 'Bitte Nachnamen eingeben',
        missingEmail: 'Bitte Email eingeben',
        incorrectEmail: 'Bitte eine gültige Email Adresse eingeben',
        emailPotentiallyIncorrect: 'Bist Du sicher, dass diese E-Mail Adresse stimmt?',
        missingBirthDate: 'Bitte wähle dein Geburtsdatum aus',
        tosNotAccepted: 'Bitte bestätige unsere Nutzungsbestimmungen',
        missingGender: 'Bitte wähle ein Geschlecht aus',
    }
}